<style src="./ContextTextFilter.scss" lang="scss"></style>
<template>
  <section class="text-filter">
    <form @submit.prevent="sendFilter" class="rowsection">
      <span class="filtertitle">Filtrar por Valor</span>
      <div class="filters">
        <select class="cp1-small-select selection" v-model="filters.filterType">
          <option
            v-for="(filterType, filterTypeIdx) in filters.filterTypesByValue"
            :key="filterTypeIdx"
            :value="filterTypeIdx"
            >{{ filterType }}</option
          >
        </select>
        <input
          type="text"
          v-model="filters.filterValue"
          placeholder="10"
          class="cp1-small-textbox searchtext"
        />
        <button class="cp1-small-button cp1-button__success filterbutton">
          Filtrar
        </button>
        <button
          type="button"
          class="cp1-small-button cp1-button__danger cleanbutton"
          @click="cleanFilter"
        >
          <icon-close class="icon" />
        </button>
      </div>
    </form>
  </section>
</template>

<script>
import { IconClose } from "@/components/primitives/icons";

const FilterTypes = {
  "0": "Nenhum Filtro",
  LIST: "Contém",
  LIKE: "Contém",
  GT: "Maior que",
  LT: "Menor que",
  EQ: "Igual a"
};

export default {
  name: "GenericContextFilter",
  components: {
    IconClose
  },
  props: {
    columnId: {
      default: null
    },
    activeOptions: {
      default: 0
    },
    activeType: {
      default: 0
    }
  },
  data: () => ({
    filters: {
      filterTypesByValue: FilterTypes,
      filterType: "0",
      filterValue: null
    }
  }),
  mounted() {
    this.filters.filterValue = this.activeOptions;
    this.filters.filterType = this.activeType;
  },
  methods: {
    sendFilter() {
      if (this.filters.filterType === "0") {
        this.filters.filterValue = null;
      }
      const filter = {
        columnId: this.columnId,
        filterType: this.filters.filterType,
        filterValue: this.filters.filterValue
      };
      this.$emit("filter-value", filter);
    },
    cleanFilter() {
      this.filters.filterValue = null;
      this.filters.filterType = "0";
      this.$emit("clean-filter", { columnId: this.columnId });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/view/item-pricing/components/context-text-filter/ContextTextFilter.vue